<div class="pt-4">
  <p class="text-gray-600 mb-4">{{ 'waters.season-periods.exceptions-hint' | translate }}</p>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-40 mb-4">
    <mat-label>{{ 'waters.season-periods.year' | translate }}</mat-label>
    <mat-select [value]="selectedYear()" (selectionChange)="onYearChange($event.value)">
      @for (year of yearOptions(); track year) {
        <mat-option [value]="year">{{ year }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (isLoading()) {
    <div class="flex justify-center items-center h-40">
      <mat-spinner diameter="40" />
    </div>
  } @else {
    <app-season-period-table [rows]="rows()" (rowsChange)="onRowsChange($event)" />

    <div class="flex justify-end items-center gap-3 mt-4">
      @if (showValidationError()) {
        <span class="text-sm text-red-600">{{ 'waters.season-periods.invalid-hint-exceptions' | translate }}</span>
      }
      <button mat-flat-button color="primary" [disabled]="isSaving()" (click)="save()">
        @if (isSaving()) {
          <mat-spinner diameter="18" />
        } @else {
          {{ 'waters.form.save' | translate }}
        }
      </button>
    </div>
  }
</div>
